/**
 * Localization selector: close the desktop disclosure on Escape and outside
 * click, and navigate when the mobile select changes.
 * Progressive enhancement over native <details> and <select>.
 */
(() => {
  const SELECTOR = '[data-localization-selector]';
  const SELECT_SELECTOR = '[data-localization-select]';

  const closeDetails = (details) => {
    if (details.open) {
      details.open = false;
    }
  };

  const onDocumentClick = (event) => {
    for (const details of document.querySelectorAll(`${SELECTOR}[open]`)) {
      if (!details.contains(event.target)) {
        closeDetails(details);
      }
    }
  };

  const onDocumentKeydown = (event) => {
    if (event.key !== 'Escape') return;

    for (const details of document.querySelectorAll(`${SELECTOR}[open]`)) {
      closeDetails(details);
      const summary = details.querySelector('summary');
      if (summary) summary.focus();
    }
  };

  const onDocumentChange = (event) => {
    const select = event.target.closest(SELECT_SELECTOR);
    if (!select) return;

    // The active store's option carries no value, so staying put is a no-op.
    const url = select.value;
    if (!url) return;

    window.location.href = url;
  };

  // Back (and Safari bfcache) restores the select on the store we just left.
  // Re-picking that option then does not fire change, so snap back to the
  // empty current-store option whenever the page is shown.
  const resetNativeSelects = () => {
    for (const select of document.querySelectorAll(SELECT_SELECTOR)) {
      const current = select.querySelector('option[value=""]');
      if (current) current.selected = true;
    }
  };

  if (!window.__meacoLocalizationSelectorBound) {
    window.__meacoLocalizationSelectorBound = true;
    document.addEventListener('click', onDocumentClick);
    document.addEventListener('keydown', onDocumentKeydown);
    document.addEventListener('change', onDocumentChange);
    window.addEventListener('pageshow', resetNativeSelects);
  }
})();
